module.exports = __webpack_public_path__ + "static/media/java.fe48028a.svg";